module.exports = __webpack_public_path__ + "img/ph.3905c1f5.png";